var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNotepad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99875 21.0037H4.99708C3.89205 21.0037 2.99625 20.1079 2.99625 19.0029V4.99708C2.99625 3.89205 3.89205 2.99625 4.99708 2.99625H17.0021C18.1071 2.99625 19.0029 3.89205 19.0029 4.99708V7.99833",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99792 7.99833H13.0004",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99792 12H8.99876",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21.0038L14.6261 20.6796C14.8107 20.6563 14.9823 20.5726 15.1143 20.4415L21.4759 14.0799C21.8153 13.7419 22.0061 13.2828 22.0061 12.8038C22.0061 12.3249 21.8153 11.8657 21.4759 11.5278V11.5278C21.138 11.1884 20.6788 10.9977 20.1999 10.9977C19.721 10.9977 19.2618 11.1884 18.9239 11.5278L12.6213 17.8304C12.4936 17.9582 12.4107 18.1238 12.3852 18.3026L12 21.0038Z",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotepad);
export default __webpack_public_path__ + "static/media/notepad.ce26b3ede4dbf6068de137e3becde186.svg";
export { ForwardRef as ReactComponent };